export default "__VITE_ASSET__QslPszVZ__"